<!--<div mat-dialog-content class="mat-typography">{{ message }}</div mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>-->
{{ message }}
